import { NavLink, Outlet } from 'react-router-dom'
import { useT } from '@/i18n/I18nProvider'

export function SettingsLayout() {
  const t = useT()
  return (
    <div className="grid grid-cols-[200px_1fr] gap-6">
      <nav className="flex flex-col gap-1 text-sm">
        <h2 className="text-xs uppercase tracking-wide opacity-60 mb-2 px-2">{t('settings.nav.title')}</h2>
        <Item to="profile" label={t('settings.nav.profile')} />
        <Item to="team" label={t('settings.nav.team')} />
        <Item to="integrations" label={t('settings.nav.integrations')} />
        <Item to="security" label={t('settings.nav.security')} />
        <Item to="danger" label={t('settings.nav.danger')} />
      </nav>
      <div>
        <Outlet />
      </div>
    </div>
  )
}

function Item({ to, label }: { to: string; label: string }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `px-2 py-1.5 rounded ${isActive ? 'bg-black/5 dark:bg-white/5 font-medium' : 'opacity-80 hover:opacity-100'}`
      }
    >
      {label}
    </NavLink>
  )
}
